var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncements(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.8333C21 13.6149 21 14.3849 21 15.1666C22.4 15.1666 24.22 15.1666 25.6667 15.1666C25.6667 14.3849 25.6667 13.6149 25.6667 12.8333C24.22 12.8333 22.4 12.8333 21 12.8333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 20.5451C19.7866 21.3734 21.245 22.4701 22.4 23.3334C22.8666 22.7151 23.3333 22.0851 23.8 21.4667C22.645 20.6034 21.1866 19.5067 20.0666 18.6667C19.6 19.2967 19.1333 19.9267 18.6666 20.5451Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 6.53341C23.3333 5.91508 22.8666 5.28508 22.4 4.66675C21.245 5.53008 19.7866 6.62675 18.6666 7.46675C19.1333 8.08508 19.6 8.71508 20.0666 9.33342C21.1866 8.49341 22.645 7.40841 23.8 6.53341Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66671 10.5C3.38337 10.5 2.33337 11.55 2.33337 12.8333L2.33337 15.1667C2.33337 16.45 3.38337 17.5 4.66671 17.5H5.83337V22.1667H8.16671V17.5H9.33337L15.1667 21V7L9.33337 10.5H4.66671ZM10.535 12.495L12.8334 11.1183V16.8817L10.535 15.505L9.97504 15.1667H9.33337H4.66671V12.8333H9.33337H9.97504L10.535 12.495Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0834 13.9999C18.0834 12.4482 17.4067 11.0482 16.3334 10.0916V17.8966C17.4067 16.9516 18.0834 15.5516 18.0834 13.9999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.fba888d6.svg";
export { ForwardRef as ReactComponent };